import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/avatar'
import { IMG_BASE_PATH } from '@/const'
import { motion } from 'motion/react'
import { PlatformMarketingCard } from '../groupPlatformItems'
import { LandingSection } from '../LandingSection'

function initials(name: string) {
  return (
    name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .toUpperCase() || '?'
  )
}

export function ContactSection({ items }: { items: PlatformMarketingCard[] }) {
  return (
    <LandingSection
      id="get-in-touch"
      className="bg-background"
      eyebrow="Contact"
      title="Get in touch"
      description="Reach out to a partner to discuss the app and engagement that fits your needs."
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item, index) => {
          const name = item.card.title
          const imageSrc = item.card.image ? `${IMG_BASE_PATH}${item.card.image}` : undefined

          return (
            <motion.article
              key={item.email || name}
              className="flex items-center gap-4 rounded-xl border border-border bg-card p-4"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45, delay: index * 0.05 }}
            >
              <Avatar className="h-14 w-14">
                <AvatarImage src={imageSrc} alt={name} />
                <AvatarFallback className="bg-primary/10 font-medium text-primary">{initials(name)}</AvatarFallback>
              </Avatar>
              <div className="min-w-0 leading-tight">
                <p className="font-medium text-card-foreground">{name}</p>
                {item.card.description && <p className="mt-1 text-sm text-muted-foreground">{item.card.description}</p>}
                {item.email && (
                  <a
                    href={`mailto:${item.email}`}
                    className="mt-1 inline-block truncate text-sm text-primary transition-colors hover:text-primary/80"
                  >
                    {item.email}
                  </a>
                )}
              </div>
            </motion.article>
          )
        })}
      </div>
    </LandingSection>
  )
}
